import { restClient } from 'config/store/configureStore';
import { OFFERS_FILTER_URL, OFFERS_EXPORT_URL, OFFERS_URL, OFFERS_API_URL } from 'constants/ApiConstants';

import { resolveLink } from '../UrlResolver';

export default {
  getOffers: (links, parameters) => {
    const filterUrl = OFFERS_FILTER_URL;
    const { url, params } = resolveLink(links, filterUrl, parameters);
    return restClient.get(url, { params });
  },

  getOffer: (offerId, params) => restClient.get(`${OFFERS_URL}/${offerId}?projection=details`, { params }),

  saveOffer: offer => {
    if (offer.id) {
      return restClient.put(`${OFFERS_API_URL}/${offer.id}`, offer);
    }
    return restClient.post(OFFERS_API_URL, offer);
  },

  copyOffer: offerId => restClient.post(`${OFFERS_API_URL}/${offerId}/clone`),

  deleteOffer: id => restClient.delete(`${OFFERS_API_URL}/${id}`),

  getPdfOffer: (id, timezone) => restClient.get(`${OFFERS_API_URL}/${id}/pdf?timezone=${timezone}`),

  exportOffers: (customer, reference) =>
    restClient.get(OFFERS_EXPORT_URL, {
      params: { customer, reference },
    }),
};
